import {BrowserRouter as Router, Link, Route, Routes} from "react-router-dom";
import { useEffect, useState, Suspense, lazy } from 'react';
import axios from "axios";
import './App.css';
import tsvToArray from "./helpers";
// import Cookies from "js-cookie";
import "./views/Authenticator.css";
// https://legacy.reactjs.org/docs/code-splitting.html#route-based-code-splitting
// import MapContainer from "./components/MapContainer";
import Filters from "./components/Filters";
import Text from "./views/Text";
import {GrClose} from "react-icons/gr";
import { onSnapshot, doc } from "firebase/firestore";
import { createUserWithEmailAndPassword, onAuthStateChanged, signInWithEmailAndPassword, sendEmailVerification, signOut } from "firebase/auth";
import {auth, db} from "./utils/firebase";
import { SpeedInsights } from "@vercel/speed-insights/react";

const Intro = lazy(() => import("./components/Intro"));
const Image = lazy(() => import("./views/Image"));
const Preview = lazy(() => import("./views/Preview"));
const MapContainer = lazy(() => import("./components/MapContainer"));
const BlurryBackdrop = lazy(() => import("./components/BlurryBackdrop"));

const isMobileDevice = () => {
    const userAgentMatches = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    const viewportMatches = window.matchMedia ? window.matchMedia('(max-width: 768px)').matches : false;
    return userAgentMatches || viewportMatches;
};

function App() {
    const [adminProps, setAdminProps] = useState(
        {
            locked: true,
            signUpLocked: true
        });
    // const annoCollection = collection(db, "anno");
    const [isMobile, setIsMobile] = useState(false);
    const [showIntro, setShowIntro] = useState(true);

    const [data, setData] = useState([]);
    // const [annoData, setAnnoData] = useState([]);
    const [filteredYear, setFilteredYear] = useState(null);
    const [filteredCountry, setFilteredCountry] = useState(null);
    const [center, setCenter] = useState(null);
    const [user, setUser] = useState(null);
    const [authError, setAuthError] = useState("");
    const [authMessage, setAuthMessage] = useState("");
    const [authForm, setAuthForm] = useState({
        email: "",
        password: "",
    });
    const [isSubmitting, setIsSubmitting] = useState(false);

    // const [timer, setTimer] = useState(0);

    const [showAuth, setShowAuth] = useState(false);
    const [isSignUp, setIsSignUp] = useState(true);

    useEffect(() => {
        const updateMobileState = () => {
            const mobile = isMobileDevice();
            setIsMobile(mobile);
            if (!mobile) setShowIntro(true);
        };

        updateMobileState();
        window.addEventListener('resize', updateMobileState);

        return () => window.removeEventListener('resize', updateMobileState);
    }, []);

    function handleSignOut() {
        signOut(auth).then(() =>
            setUser(null)
        );
    }

    // useEffect(() => {
    //     // const data = await getDocs(annoCollection);
    //     // let docs = data.docs.map((doc) => ({ ...doc.data(), id: doc.id }))
    //     // setAnnoData(docs)
    //     const unsubscribe = onSnapshot(collection(db, "anno"), data => {
    //         data.docs.forEach(doc => {
    //             console.log(doc.type)
    //         })
    //         setAnnoData(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })))
    //     }, err => {
    //         console.log('Error fetching annotations: ', err);
    //     })
    //     return () => unsubscribe();
    // }, [])

    useEffect(() => {
        const unsubscribe = onSnapshot(doc(db, "admin", "anno"), (doc) => {
            console.log(doc.data());
            setAdminProps(doc.data()); // Update state with entire snapshot at once
        }, err => {
            console.log('Error fetching admin props: ', err);
        });
        // Cleanup listener when component unmounts
        return () => unsubscribe();

        // const adminData = getDocs(adminCtrl);
        // let locked = adminData.docs.map((doc) => ({ ...doc.data(), id: doc.id }))
        // setIsLocked(locked[0].locked)
    }, []);

    // useEffect(() => {
    //     const interval = setInterval(() => {
    //         setTimer(prev => prev + 1);
    //     }, 1000);
    //     setFilteredYear(timer % 9 + 1946);
    //     return () => clearInzterval(interval);
    // }, [timer]);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, currentUser => {
            if (currentUser) {
                setUser(currentUser.email);
            } else {
                setUser(null);
            }
        });

        return () => unsubscribe();
    }, []);


    useEffect(()=> {
        const getData = async () => {
            try {
                let response = await axios.get('./images.tsv');
                setData(tsvToArray(response.data));
            } catch (err) {
                setData(null);
            }
        };
        getData();
    }, []);

    const handleAuthSubmit = async (event) => {
        event.preventDefault();
        setAuthError("");
        setAuthMessage("");
        setIsSubmitting(true);
        try {
            if (isSignUp) {
                const userCredential = await createUserWithEmailAndPassword(auth, authForm.email, authForm.password);
                try {
                    await sendEmailVerification(userCredential.user);
                    setAuthMessage("Check your email for a verification link before signing in.");
                } catch (verificationError) {
                    setAuthError(verificationError.message || "Failed to send verification email. Please try again.");
                }
            } else {
                await signInWithEmailAndPassword(auth, authForm.email, authForm.password);
                setShowAuth(false);
            }
            setAuthForm({ email: "", password: "" });
        } catch (err) {
            setAuthError(err.message || "Authentication failed.");
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleMobileIntroDismiss = () => {
        if (isMobile) setShowIntro(false);
    };

    return (
        <Router>
            <Suspense fallback={<div>Loading...</div>}>
                <Routes>
                    <Route
                        path="/"
                        element={
                            !isMobile ? (
                                <><BlurryBackdrop isMobile={isMobile}/>
                                    <Intro
                                        data={data}
                                        user={user}
                                        onShowAuth={setShowAuth}
                                        onInOrUp={setIsSignUp}
                                        isMobile={isMobile}
                                    /></>
                            ) : showIntro ? (
                                <div
                                    className="mobile-intro-overlay"
                                    onClick={handleMobileIntroDismiss}
                                >
                                    <div
                                        className="mobile-intro-surface"
                                        onClick={(event) => event.stopPropagation()}
                                    >
                                        <BlurryBackdrop isMobile={isMobile}/>
                                        <Intro
                                            data={data}
                                            user={user}
                                            onShowAuth={setShowAuth}
                                            onInOrUp={setIsSignUp}
                                            isMobile={isMobile}
                                            onClose={handleMobileIntroDismiss}
                                        />
                                    </div>
                                </div>
                            ) : null
                        }
                    />
                    <Route
                        path="/map"
                        element={<div />}
                    />
                    <Route
                        path="/images"
                        element={<Image data={data} user={user} filteredYear={filteredYear} isLocked={adminProps.locked}
                            // annoData={annoData}
                        />}
                    />
                    <Route
                        path="/preview"
                        element={<Preview data={data} />}
                    />
                    <Route
                        path="/r/:textId"
                        element={<Text />}
                    />
                </Routes>
            </Suspense>
            <MapContainer data={data}
                year={filteredYear}
                center={center}
                user={user}
                country={filteredCountry}
                onShowAuth={setShowAuth}
                onInOrUp={setIsSignUp}
                isMobile={isMobile}
                introOpen={isMobile && showIntro}
            />
            {!isMobile ?
                <Filters data={data}
                    onYearChange={setFilteredYear}
                    onCountryChange={setFilteredCountry}
                /> : null
            }
            <Link className='absolute top-0 left-1 text-gray-900 cursor-pointer font-sans hover:mix-blend-difference'
                style={{fontSize: '1.25rem'}} to={"/"}>
                about
            </Link>
            {
                !user ?
                    <div className='absolute left-1 bottom-1 text-gray-900 cursor-pointer font-sans hover:mix-blend-difference'
                    style={{fontSize: '1.25rem'}}
                        onClick={() => {
                            setShowAuth(bool => !bool);
                            setIsSignUp(true);
                        }}
                    >
                        <p className='w-fit m-auto cursor-pointer'>sign up</p>
                    </div> : null
            }
            {
                !isMobile ?
                    user ?
                        <div className='absolute right-1 bottom-1 text-gray-900 cursor-pointer font-sans hover:mix-blend-difference'
                            style={{fontSize: '1.25rem'}}
                            onClick={handleSignOut}>
                            sign out
                        </div> :
                        <div className='absolute right-1 bottom-1 text-gray-900 cursor-pointer font-sans hover:mix-blend-difference'
                            style={{fontSize: '1.25rem'}}
                            onClick={() => {
                                setShowAuth(bool => !bool);
                                setIsSignUp(false);
                            }}>
                            sign in
                        </div> : null
            }
            {showAuth ?
                adminProps.signUpLocked && isSignUp ?
                    <div className='auth-container bg-[rgba(255,255,255,0.5)] p-[20px] pt-0'>
                        <div className='close'
                            onClick={() => setShowAuth(false)}
                        >
                            <GrClose size={15} />
                        </div>
                        <p className="pt-5 text-sm">
                            Sign up is currently disabled. Check back for the next <i>Memex Room</i>. See previous workshops <a href
="https://torontobiennial.org/programs/memex-room-reindexing-the-archive/" target="_blank" rel="noreferrer">here</a>.
                        </p>
                    </div>
                    :
                    <div className='auth-container bg-gray-50'>
                        <div className='close'
                            onClick={() => setShowAuth(false)}
                        >
                            <GrClose size={15} />
                        </div>
                        <div className='auth'>
                            <div className="flex justify-between items-center mb-3">
                                <button
                                    className={`auth-toggle ${isSignUp ? "active" : ""}`}
                                    type="button"
                                    onClick={() => setIsSignUp(true)}
                                >
                                    sign up
                                </button>
                                <button
                                    className={`auth-toggle ${!isSignUp ? "active" : ""}`}
                                    type="button"
                                    onClick={() => setIsSignUp(false)}
                                >
                                    sign in
                                </button>
                            </div>
                            <form className="auth-form" onSubmit={handleAuthSubmit}>
                                <label className="label" htmlFor="email">email</label>
                                <input
                                    id="email"
                                    name="email"
                                    type="email"
                                    autoComplete="email"
                                    value={authForm.email}
                                    onChange={(e) => setAuthForm({...authForm, email: e.target.value})}
                                    defaultValue="email"
                                    required
                                />
                                <label className="label" htmlFor="password">password</label>
                                <input
                                    id="password"
                                    name="password"
                                    type="password"
                                    autoComplete={isSignUp ? "new-password" : "current-password"}
                                    value={authForm.password}
                                    onChange={(e) => setAuthForm({...authForm, password: e.target.value})}
                                    required
                                    minLength={6}
                                />
                                {authError ? (
                                    <p className="auth-error">{authError}</p>
                                ) : null}
                                {authMessage ? (
                                    <p className="auth-message">{authMessage}</p>
                                ) : null}
                                <button className="auth-submit" type="submit" disabled={isSubmitting}>
                                    {isSubmitting ? "loading..." : isSignUp ? "create account" : "sign in"}
                                </button>
                            </form>
                        </div>
                    </div> : <div />
            }
            <SpeedInsights />
        </Router>
    );
}

export default App;
